// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-2sf8K"};